import { useTranslatedMessages } from './useTranslatedMessages';
import {
  BULK_UPLOAD_MODULE_KEY,
  DOCUMENT_REPORT_MODULE_KEY,
  PURCHASE_MODULE_KEY,
  SALES_MODULE_KEY,
  VAT_REPORT_MODULE_KEY,
} from '../resources/settings/constants/roleModules';

const ROLE_MODULE_LABEL_FALLBACKS = {
  [SALES_MODULE_KEY]: 'Sales',
  [PURCHASE_MODULE_KEY]: 'Purchase',
  [DOCUMENT_REPORT_MODULE_KEY]: 'Document Reports',
  [VAT_REPORT_MODULE_KEY]: 'VAT Reports',
  [BULK_UPLOAD_MODULE_KEY]: 'Bulk Upload',
};

export function useRoleModuleLabel(moduleKey) {
  const { settings } = useTranslatedMessages();
  const modules = settings?.team?.modules ?? {};

  return modules[moduleKey] || ROLE_MODULE_LABEL_FALLBACKS[moduleKey] || moduleKey;
}
